// extracted by mini-css-extract-plugin
module.exports = {"group":"XQbTo","label":"wCgQr","wrapper":"hRuRD","container":"_17fmK","vertical":"fo7ms","checkmark":"z1RUk"};